import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useDashboardStyles = makeStyles((theme) => ({
    paper: {
        borderRadius: "30px",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
        padding: theme.spacing(3),
        backgroundColor: COLORS.backgroundLight,
    },
    panleLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        letterSpacing: 1,
    },
    greeting: {
        fontSize: 36,
        fontWeight: 700,
        color: COLORS.textPrimary,
        lineHeight: 1.2,
    },
    greetingName: {
        color: theme.palette.primary.main,
    },
    dateText: {
        fontSize: 14,
        color: COLORS.textSecondary,
        marginTop: 6,
        marginBottom: theme.spacing(3),
    },
    chartCard: {
        padding: theme.spacing(2.5),
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    chartTitle: {
        fontWeight: 'bold',
        fontSize: '18px',
        color: COLORS.textPrimary,
        marginBottom: theme.spacing(1),
    },
    headerActions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    refreshBtn: {
        borderRadius: '20px',
        textTransform: 'none',
        fontWeight: 'bold',
    },
    downloadBtn: {
        borderRadius: '5px',
        textTransform: 'none',
        fontWeight: 'bold',
        backgroundColor: '#00ADEE',
        color: 'white',
        '&:hover': {
            backgroundColor: '#1976d2',
        },
    },
}));

export default useDashboardStyles;